module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "login-box elevation-23 bg"
  }, [_c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "indeterminate": true,
      "height": 3
    }
  }), _vm._v(" "), _c('v-card-title', [_c('img', {
    staticClass: "login-header",
    attrs: {
      "width": "330",
      "height": "80",
      "src": "https://s3.eu-central-1.amazonaws.com/static.appointmentguru.co/images/logo.png"
    }
  })]), _vm._v(" "), (_vm.requests.start.status !== 401) ? _c('request-status', {
    attrs: {
      "request": _vm.requests.start,
      "message200": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status !== _vm.states.LOGIN) ? _c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 70,
      "color": "amber",
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "headline mt-4"
  }, [_vm._v(_vm._s(_vm.statusMessage))]), _vm._v(" "), (_vm.requests.start.status === 500) ? _c('v-card-actions', {
    staticStyle: {
      "background-color": "white",
      "border-top": "solid 1px #ccc"
    }
  }, [_vm._v("\n      Login request failed. Try again?\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.start.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v("Retry")])], 1) : _vm._e()], 1) : _c('v-card-text', [_c('v-window', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', [_c('request-status', {
    attrs: {
      "request": _vm.requests.login,
      "message200": false,
      "message401": "Authentication failed. Invalid username or password"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "name": "id-username",
      "id": "id-username",
      "label": "Your e-mail address",
      "persistent-hint": ""
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "name": "id-password",
      "type": "password",
      "label": "Password",
      "persistent-hint": ""
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "background-color": "white",
      "border-top": "solid 1px #ccc"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.prepareLinkPage
    }
  }, [_vm._v("Send me a login link")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('request-status', {
    attrs: {
      "request": _vm.requests.requestOTP
    }
  }), _vm._v(" "), (_vm.requests.login.status === 401) ? _c('v-alert', {
    attrs: {
      "value": true
    }
  }, [_vm._v("\n          The code you entered is incorrect or has expired\n        ")]) : _vm._e(), _vm._v(" "), (_vm.requests.requestOTP.status != 200) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "name": "id-email",
      "id": "id-email",
      "type": "email",
      "label": "Your e-mail address",
      "hint": "If you have an account, we will send an code to this email which you can enter below",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "color": "primary",
      "disabled": !_vm.email
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v("Send code")])], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "name": "id-code",
      "id": "id-code",
      "label": "Type your code in here",
      "hint": "We sent it to your email address. Check your SPAM folder if you can't see it",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v("Resend code")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.step === 1) ? _c('v-card-actions', {
    staticStyle: {
      "background-color": "white",
      "border-top": "solid 1px #ccc"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 0
      }
    }
  }, [_vm._v("Back to login")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.code.length != 4,
      "loading": _vm.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Verify")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35a1ed22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Login.vue
// module id = 1388
// module chunks = 9